import { NgIf, NgIfContext } from '@angular/common';
import { ChangeDetectorRef, Directive, Input, OnChanges, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { AbIfService } from '@df/module-ab/ab-if.service';
import { AbService } from '@df/module-ab/ab.service';

/**
 * Diretive used to place elements only for particular versions of experiments
 *
 * ## usage
 *
 * *abIf="'(menu) A'"
 * *abIf="'(menu) !B'"
 * *abIf="'(menu) A,B'"
 *
 * Where menu is human readable experiment id
 * and A, B are letter style versions
 **/

@Directive({
    selector: '[abIf]',
    standalone: true
})
export class AbIfDirective extends NgIf implements OnInit, OnChanges, OnDestroy {
    @Input({
        required: true
    })
    abIf!: string;

    private subscription?: Subscription;

    private initiated = false;

    constructor(
        viewContainerRerf: ViewContainerRef,
        templateRef: TemplateRef<NgIfContext<unknown>>,
        private abService: AbService,
        private abIfService: AbIfService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        super(viewContainerRerf, templateRef);
    }

    ngOnInit(): void {
        this.initiated = true;
    }

    ngOnChanges(): void {
        this.subscription?.unsubscribe();
        this.subscription = this.abIfService.getState(this.abIf).subscribe(val => {
            this.ngIf = val;
            if (this.initiated) {
                this.changeDetectorRef.detectChanges();
            }
        });
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
}
